'use strict';

class Page04 extends BaseComponent {
    constructor(element, state) {
        //init BaseComponent
        super(element, state);

        //set template id
        this._view = $('#page04_Page04').html();

        this.state.pageNumber = 4;

        //set template props
        this._props = {
            intro: _t('page04_intro'),
            caption0404: _t('page04_caption')
        };

        // _.bindAll(this, 'onClickTargetMarker', 'onClickBtnShowMarkers');
        _.bindAll(this, 'onClickTargetMarker');

        return this
    }

    init() {
        //gotoNextPage
        this.gotoNextPage = new GotoNextPage($('div.goto-next-page', this.$el), {urlNext: 'page05', pageNumber: this.state.pageNumber + 1}).render().init();
        this.$captions = $('.caption', this.$el);
        this.$targetMarkers = $('.target-marker', this.$el);

        this.$targetMarkers.on('click', this.onClickTargetMarker);

        this.$introCopy = $('.intro-copy', this.$el);
        this.$image = $('.img-wrapper', this.$el);
        this.$image2 = $('.vesuvio2', this.$el);

        //fade in animation
        this.fadeHideElement(this.$introCopy)
            .fadeHideElement(this.$image)
            .fadeHideElement(this.$captions);

        this.timeline = new TimelineLite();
        this.timeline.call(this.fadeInElement, [this.$introCopy], this, "+=0.3");
        this.timeline.call(this.fadeInElement, [this.$image], this, "+=0.5");
        this.timeline.play();


        return this
    }

    onClickTargetMarker(evt) {

        let targetId = $(evt.currentTarget).data('target');
        let $target = $('#'+targetId, this.$el);
        let doShow = $target.hasClass('fade-hide');
        this.fadeHideElement(this.$captions);
        //this.$captions.addClass('hidden');
        if(doShow) {
            this.fadeInElement($target);
            //$target.removeClass('hidden');
            this.fadeInElement(this.$image2);
        }
        site.instance.updateViewport();
    }
}

if(!_.isObjectLike(site)) var site = {components:{}};
site.components.Page04 = Page04;
